import { developerProjectsFrenchData } from "./dev.projects.data";
import { developerProjectsEnglishData } from "./dev.projects.data";

export interface ProjectModel {
  title: string;
  description: string;
  logo: string;
  image: string;
}
export const PROJECTS_DATA = {
  en: [
    developerProjectsEnglishData,
    // graphicDesignerProjectsEnglishData,
  ],
  fr: [
    developerProjectsFrenchData,
    // graphicDesignerProjectsFrenchData,
  ],
};
